import { jsxs as t, jsx as l } from "react/jsx-runtime";
import { svgIconStyles as r } from "../svg-icon/SvgIcon.styles.js";
function d({
  label: e,
  className: i,
  size: n,
  ...o
}) {
  return /* @__PURE__ */ t(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "meinsOutline",
      stroke: "none",
      role: "img",
      "aria-hidden": !e,
      focusable: "false",
      className: r({ className: i, size: n }),
      ...o,
      children: [
        e && /* @__PURE__ */ l("title", { children: e }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2C9.23855 2 6.99997 4.23858 6.99997 7C6.99997 9.76142 9.23855 12 12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2ZM8.99997 7C8.99997 5.34315 10.3431 4 12 4C13.6568 4 15 5.34315 15 7C15 8.65685 13.6568 10 12 10C10.3431 10 8.99997 8.65685 8.99997 7Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M4.22205 21.1203C4.10245 21.617 3.67845 22 3.1676 22C2.56874 22 2.09642 21.4808 2.22186 20.8953C3.18846 16.3831 7.19914 13 12 13C16.8008 13 20.8115 16.3831 21.7781 20.8953C21.9035 21.4808 21.4312 22 20.8324 22C20.3215 22 19.8975 21.617 19.7779 21.1203C18.9324 17.609 15.7708 15 12 15C8.22911 15 5.06759 17.609 4.22205 21.1203Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  d as MeinsOutlineIcon,
  d as default
};
